import React from 'react';

const AnalyticsPage = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Analyses Avancées</h1>
        <p className="page-subtitle">
          Visualisations détaillées, tendances et insights de données
        </p>
      </div>
      <div className="card">
        <p className="text-center text-gray-600 py-8">
          Section d'analyses en cours de développement.
        </p>
      </div>
    </div>
  );
};

export default AnalyticsPage;